import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthService } from '../app/utility/auth/auth.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatbotComponent } from '@serengeti/serengeti-chatbot';

const routes: Routes = [
  { path: 'main', component: AppComponent, canActivate: [AuthService], children: [
    { path: 'chatbot', component: ChatbotComponent, outlet: 'content', canActivate: [AuthService], data: { root: true }},
  ]}
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
    CommonModule
  ]
})
export class AppRoutingChatbotModule { }
